import { withRouter } from "react-router-dom";

import loadable from "~/app/utils/loadable";

export const ErrorBoundaryWithoutRouter = loadable(
  () => import("./ErrorBoundary"),
  {
    fallback: null,
  }
);

export default withRouter(
  loadable(() => import("./ErrorBoundary"), {
    fallback: null,
  })
);
